import { type FunctionComponent } from 'react';
import classes from './ProviderSearchHome.module.css';
import Image from 'next/image';
import { Stack } from '@mantine/core';
import ProviderSearchForm from '@/components/ProviderSearch/ProviderSearchForm';
import { useFeatureFlag } from '@/contexts/FeatureFlag/FeatureFlag';
import InfoBanner from '@/components/InfoBanner';

const EMPLOYEE_PLAN_URL =
  'https://healthcomp.sapphirecareselect.com/?ci=CP253&network_id=131&geo_location=40.498099999999994,-74.5245&locale=en';

const ProviderSearchHome: FunctionComponent = () => {
  const showEmployeeRedirectLink = useFeatureFlag(
    'nwdShowEmployeeRedirectMessage'
  );

  return (
    <div className={classes.root}>
      <Image
        src="/images/nwd/homeFamily.jpg"
        priority={true}
        width={0}
        height={0}
        sizes="100vw"
        alt=""
        className={classes.bannerImage}
      />
      <Stack gap={8} flex={1}>
        <h1 className={classes.findCare}>Find Care</h1>
        <p className={classes.title}>
          Locate a Tier 1 Northwell Direct provider nearest you
        </p>
        {showEmployeeRedirectLink && (
          <InfoBanner
            meaning="neutral"
            icon="custom/i"
            title="Northwell Employee plan">
            If you are enrolled in the Northwell Employee plan, please visit the{' '}
            <a href={EMPLOYEE_PLAN_URL}>
              Northwell Employee plan provider search
            </a>{' '}
            to search your in-network providers.
          </InfoBanner>
        )}
        <ProviderSearchForm />
      </Stack>
    </div>
  );
};

export default ProviderSearchHome;
